import { User } from '../main'

interface GalaxyBrowserPageProps {
  user?: User
}

export function GalaxyBrowserPage({ user }: GalaxyBrowserPageProps) {
  return (
    <div className="page">
      <div className="container">
        <div className="hero">
          <h1>Galaxy Browser</h1>
          <p className="hero-subtitle">
            Discover and join galaxies across the SWGRealms universe
          </p>
        </div>

        <div className="swg-window">
          <div className="swg-window-header">
            <h3>Imperial Notice - Form 27-B Status Update</h3>
          </div>
          <div className="swg-window-content">
            <div className="status-indicator status-warning mb-md">
              <span>●</span> Pending Imperial Architectural Review Board Approval
            </div>
            
            <p className="mb-md">
              Greetings, Citizen {user?.username || 'Guest'}. The <strong>Galaxy Discovery and Navigation Interface</strong> 
              has been submitted to the Imperial Architectural Review Board for final approval.
            </p>
            
            <div className="mb-md" style={{fontSize: '0.9rem', color: 'var(--swg-text-secondary)'}}>
              <div className="mb-sm">📋 <strong>Current Status:</strong> Under review by Sub-Committee 7-Alpha</div>
              <div className="mb-sm">📅 <strong>Submitted:</strong> 3 rotations ago</div>
              <div className="mb-sm">⏱️ <strong>Estimated Review Time:</strong> 2-4 standard galactic cycles</div>
              <div className="mb-sm">📝 <strong>Forms Required:</strong> 27-B, 31-C, 44-X (Pending)</div>
            </div>

            <div className="progress-bar mb-md">
              <div className="progress-fill mind" style={{width: '73%'}}></div>
              <div className="progress-text">Bureaucratic Progress: 73%</div>
            </div>

            <p style={{fontSize: '0.9rem', fontStyle: 'italic', color: 'var(--swg-text-secondary)'}}>
              "The Empire's commitment to thorough documentation ensures that all galactic navigation 
              interfaces meet the highest standards of Imperial excellence. Your patience during this 
              essential review process demonstrates your loyalty to the Galactic Empire."
            </p>
            
            <p style={{fontSize: '0.8rem', marginTop: 'var(--swg-spacing-md)'}}>
              - <em>Deputy Assistant to the Regional Manager of Galactic Interface Approval, 
              Imperial Architectural Review Board, Sub-Division 7-Alpha</em>
            </p>
          </div>
        </div>

        <div className="mt-lg">
          <div className="swg-window">
            <div className="swg-window-header">
              <h3>What to Expect</h3>
            </div>
            <div className="swg-window-content">
              <p className="mb-md">Once approved, the Galaxy Browser will feature:</p>
              <div style={{fontSize: '0.9rem'}}>
                <div className="mb-sm">🌌 Browse all available galaxies in the SWGRealms universe</div>
                <div className="mb-sm">👥 View real-time population and activity levels</div>
                <div className="mb-sm">🎮 One-click galaxy joining with automatic client configuration</div>
                <div className="mb-sm">⭐ Community ratings and reviews (pending Form 44-X approval)</div>
                <div className="mb-sm">🔍 Advanced filtering by playstyle, ruleset, and community focus</div>
              </div>
              
              <div className="mt-md">
                <button 
                  className="btn btn-secondary" 
                  disabled
                  style={{opacity: 0.6, cursor: 'not-allowed'}}
                >
                  Notify Me When Available
                </button>
                <span style={{fontSize: '0.8rem', marginLeft: 'var(--swg-spacing-sm)', color: 'var(--swg-text-secondary)'}}>
                  (Notification system pending Form 52-D approval)
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
